declare const emos3: any;
declare const dataLayer: any;
declare const __ucCmp: any;
declare const emosContent: string;

const product: HTMLElement = document.querySelector(".event__item.product__details");
const downloadLink: HTMLElement = document.querySelector(".downloadLink");
const bookButtons: NodeListOf<HTMLElement> = document.querySelectorAll(".cart__btn");
const elearningBasketButtons: NodeListOf<HTMLElement> = document.querySelectorAll(".elearning-basket");

export const GoogleAnalytictsTrackingProduct = async (): Promise<void> => {
	if ((window as { [key: string]: any }).__ucCmp !== undefined && (await __ucCmp.isInitialized())) {
		dataLayer.push({
			event: "eec.productDetailImpression",
			ecommerce: {
				detail: {
					products: [
						{
							name: product.getAttribute("data-name"),
							id: product.getAttribute("data-pid"),
							price: Number(product.getAttribute("data-price")).toFixed(2),
							category: product.getAttribute("data-group"),
							variant: product.getAttribute("data-var1")
						}
					]
				}
			}
		});
	} else {
		setTimeout(GoogleAnalytictsTrackingProduct, 100);
	}
};

export const EcondaTrackingCart = (): void => {
	bookButtons.forEach(function(button) {
		button.addEventListener("click", AddToCartProduct);
	});
};

export const ElearningTrackingCart = (): void => {
	elearningBasketButtons.forEach(function(button) {
		button.addEventListener("click", ElearningBasketClick);
	});
};

function AddToCartProduct(this: HTMLElement): void {
	const box = this.parentElement.parentElement as HTMLElement;
	const selectedRadioButton = box.querySelector(".check__radio:checked") as HTMLInputElement;
	const priceNet = Number(selectedRadioButton?.getAttribute("data-priceNet"));
	if (typeof emos3 !== "undefined") {
		emos3.send({
			content: emosContent,
			ec_Event: [
				{
					type: "c_add",
					pid: product.getAttribute("data-pid"),
					name: product.getAttribute("data-name"),
					price: priceNet.toFixed(2),
					group: product.getAttribute("data-group"),
					count: 1,
					var1: product.getAttribute("data-var1")
				}
			]
		});
	}

	dataLayer.push({
		event: "eec.addToCart",
		ecommerce: {
			currencyCode: "EUR",
			add: {
				products: [
					{
						name: product.getAttribute("data-name"),
						id: product.getAttribute("data-pid"),
						price: Number(product.getAttribute("data-price")).toFixed(2),
						category: product.getAttribute("data-group"),
						variant: product.getAttribute("data-var1"),
						quantity: 1
					}
				]
			}
		}
	});

	dataLayer.push({
		event: "event",
		eventCategory: "product data",
		eventAction: "button_click",
		eventLabel: `buchen-button_${product.getAttribute("data-pid")}`
	});
}

function ElearningBasketClick(this: HTMLElement) {
	dataLayer.push({
		event: "event",
		eventCategory: "product data",
		eventAction: "cart clickout",
		eventLabel: `clickout_${this.getAttribute("data-productId")}`,
		eventValue: Number(this.getAttribute("data-price"))
	});
}

export const EcondaDownloadTracking = (): void => {
	if (downloadLink !== null) {
		downloadLink.addEventListener("click", trackDownload);
	}
};

export const DataLayerDownloadTracking = (): void => {
	if (downloadLink !== null) {
		downloadLink.addEventListener("click", dataLayerPush);
	}
};

function dataLayerPush() {
	dataLayer.push({
		event: "event",
		eventCategory: "product data",
		eventAction: "pdf download",
		eventLabel: `pdf_${product.getAttribute("data-pid")}`
	});
}

function trackDownload() {
	if (typeof emos3 !== "undefined") {
		emos3.send({
			content: `Produkte/Product_${product.getAttribute("data-name") }_${product.getAttribute("data-pid")}`,
			Target: ["PDF Download", `pdf_${product.getAttribute("data-pid")}`, 1, "a"],
			rqtype: "hiddenpi"
		});
	}
}
